import { ErrorsOr } from "@me8eon/errors";
import { DeleteAsyncStore, GetAsyncStore, StoreAsyncStore } from "./async.storage";

export class InMemoryGetStoreAsyncStore<Id, T> implements GetAsyncStore<Id, T>, StoreAsyncStore<Id, T>, DeleteAsyncStore<Id> {
    private cache: Map<Id, T> = new Map();


    async get(id: Id, undefinedIfNotIn?:boolean): Promise<ErrorsOr<T>> {
        const value = this.cache.get(id);
        if (value === undefined && undefinedIfNotIn) return { value: undefined as any };
        if (!value) return { errors: [`Cannot find value for id ${id}. Legal ids are ${[...this.cache.keys()].sort()}`] };
        return { value: value };
    }

    async delete(...ids: Id[]): Promise<ErrorsOr<void>> {
        for (const id of ids)
            this.cache.delete(id);
        return { value: undefined };
    }

    async store(id: Id, valye: T): Promise<ErrorsOr<void>> {
        this.cache.set(id, valye);
        return { value: undefined };
    }
}

